var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComercioIcone = function SvgComercioIcone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00196 5C4.00233 2.11879 6.68652 0 10 0C13.3135 0 16.0016 2.11879 16.0019 5H13.8219C13.8219 3.16633 12.1103 1.89648 10.0016 1.89648C7.89285 1.89648 6.18555 3.16633 6.18555 5H4.00196Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5H20V18.1084C20 19.3338 19.333 19.9583 18 19.9817C16.667 20.0052 11.333 20.0052 2 19.9817C0.667 19.9817 0 19.3573 0 18.1084V5ZM13.8219 6.87512H16.0019C15.999 9.97954 13.3138 12.4953 10.002 12.4953C6.69009 12.4953 4.00495 9.97954 4.00196 6.87512H6.18555C6.18901 8.84942 7.89714 10.4489 10.0037 10.4489C12.1103 10.4489 13.8184 8.84942 13.8219 6.87512Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComercioIcone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comercio-icone.2b833919.svg";
export { ForwardRef as ReactComponent };